(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cliente"] && !Shopify.designMode) return;
  try {
    
(function () {
  var COPIAS_LATERALES = 2;

  function iniciarCarrusel(idSeccion) {
    var seccion = document.getElementById('tv-seccion-' + idSeccion);
    var pista = document.getElementById('tv-pista-' + idSeccion);
    var btnAnterior = document.getElementById('tv-anterior-' + idSeccion);
    var btnSiguiente = document.getElementById('tv-siguiente-' + idSeccion);

    if (!pista) return;

    var nOriginales = pista.children.length;
    if (nOriginales === 0) return;

    var originales = Array.from(pista.children);

    for (var c = 0; c < COPIAS_LATERALES; c++) {
      for (var i = nOriginales - 1; i >= 0; i--) {
        var clon = originales[i].cloneNode(true);
        clon.dataset.clonado = 'true';
        pista.insertBefore(clon, pista.firstChild);
      }
    }
    for (var c = 0; c < COPIAS_LATERALES; c++) {
      for (var i = 0; i < nOriginales; i++) {
        var clon = originales[i].cloneNode(true);
        clon.dataset.clonado = 'true';
        pista.appendChild(clon);
      }
    }

    var tarjetas = Array.from(pista.querySelectorAll('.tv-tarjeta'));
    var totalTarjetas = tarjetas.length;
    var inicioOriginales = COPIAS_LATERALES * nOriginales;
    var indiceActivo = inicioOriginales + Math.floor(nOriginales / 2);
    var muteado = true;
    var yaIniciado = false;

    function gap() {
      return parseFloat(getComputedStyle(pista).gap) || 10;
    }

    function calcularOffset(indice) {
      var anchoContenedor = pista.parentElement.getBoundingClientRect().width;
      var paddingIzq = parseFloat(getComputedStyle(pista).paddingLeft) || 0;
      var g = gap();
      var anchoActiva = tarjetas[indice].getBoundingClientRect().width;
      var anchoNormal = 0;
      var contados = 0;
      for (var i = 0; i < tarjetas.length; i++) {
        if (!tarjetas[i].classList.contains('tv-tarjeta--reproduciendo')) {
          anchoNormal += tarjetas[i].getBoundingClientRect().width;
          contados++;
        }
      }
      anchoNormal = contados > 0 ? anchoNormal / contados : anchoActiva;

      var offset = 0;
      for (var i = 0; i < indice; i++) {
        var w = tarjetas[i].classList.contains('tv-tarjeta--reproduciendo') ? anchoActiva : anchoNormal;
        offset += w + g;
      }
      offset -= (anchoContenedor - anchoActiva) / 2 - paddingIzq;
      return offset;
    }

    function mostrarPlay(tarjeta) {
      var bp = tarjeta.querySelector('.tv-boton-play');
      var bpa = tarjeta.querySelector('.tv-boton-pausa');
      if (bp) bp.style.display = '';
      if (bpa) bpa.style.display = 'none';
    }

    function mostrarPausa(tarjeta) {
      var bp = tarjeta.querySelector('.tv-boton-play');
      var bpa = tarjeta.querySelector('.tv-boton-pausa');
      if (bp) bp.style.display = 'none';
      if (bpa) bpa.style.display = '';
    }

    function aplicarIconoSonido(tarjeta) {
      var im = tarjeta.querySelector('.tv-icono-mute');
      var is = tarjeta.querySelector('.tv-icono-sonido');
      if (!im || !is) return;
      im.style.display = muteado ? '' : 'none';
      is.style.display = muteado ? 'none' : '';
    }

    function aplicarMuteGlobal() {
      tarjetas.forEach(function (t) {
        var v = t.querySelector('.tv-video');
        if (v) v.muted = muteado;
        aplicarIconoSonido(t);
      });
    }

    function cargarPrimerFrame(video) {
      if (!video.src) return;
      video.load();
      var onCanPlay = function () {
        video.removeEventListener('loadeddata', onCanPlay);
        try { video.currentTime = 0.01; } catch (e) {}
      };
      video.addEventListener('loadeddata', onCanPlay);
    }

    function pausarTodosExcepto(indice) {
      tarjetas.forEach(function (tarjeta, i) {
        if (i === indice) return;
        var video = tarjeta.querySelector('.tv-video');
        if (!video) return;
        if (!video.paused) video.pause();
        video.currentTime = 0;
        tarjeta.classList.remove('tv-tarjeta--reproduciendo');
        mostrarPlay(tarjeta);
      });
    }

    function reproducirEnIndice(indice) {
      var tarjeta = tarjetas[indice];
      if (!tarjeta) return;
      var video = tarjeta.querySelector('.tv-video');
      if (!video) return;
      video.muted = muteado;
      var p = video.play();
      if (p && typeof p.then === 'function') {
        p.then(function () { mostrarPausa(tarjeta); }).catch(function () { mostrarPlay(tarjeta); });
      } else {
        mostrarPausa(tarjeta);
      }
    }

    function moverA(indice) {
      pausarTodosExcepto(indice);
      indiceActivo = indice;
      tarjetas[indice].classList.add('tv-tarjeta--reproduciendo');
      requestAnimationFrame(function () {
        var offset = calcularOffset(indice);
        pista.style.transform = 'translateX(' + (-offset) + 'px)';
        setTimeout(function () { reproducirEnIndice(indice); }, 80);
      });
    }

    function quizasResetearPosicion() {
      var distanciaIzq = indiceActivo;
      var distanciaDer = totalTarjetas - 1 - indiceActivo;
      var umbral = nOriginales;
      if (distanciaIzq >= umbral && distanciaDer >= umbral) return;

      var indiceLogico = ((indiceActivo - inicioOriginales) % nOriginales + nOriginales) % nOriginales;
      var nuevoIndice = inicioOriginales + indiceLogico;
      if (nuevoIndice === indiceActivo) return;

      var videoViejo = tarjetas[indiceActivo].querySelector('.tv-video');
      var tiempoActual = videoViejo ? videoViejo.currentTime : 0;
      var estabaPausado = videoViejo ? videoViejo.paused : true;

      pista.style.transition = 'none';
      tarjetas.forEach(function (t) { t.style.transition = 'none'; });

      tarjetas[indiceActivo].classList.remove('tv-tarjeta--reproduciendo');
      if (videoViejo) { videoViejo.pause(); videoViejo.currentTime = 0; mostrarPlay(tarjetas[indiceActivo]); }

      indiceActivo = nuevoIndice;
      tarjetas[indiceActivo].classList.add('tv-tarjeta--reproduciendo');

      var offset = calcularOffset(indiceActivo);
      pista.style.transform = 'translateX(' + (-offset) + 'px)';
      pista.offsetHeight;

      var videoNuevo = tarjetas[indiceActivo].querySelector('.tv-video');
      if (videoNuevo) {
        videoNuevo.muted = muteado;
        try { videoNuevo.currentTime = tiempoActual; } catch (e) {}
        if (!estabaPausado) {
          var p = videoNuevo.play();
          if (p && typeof p.then === 'function') {
            p.then(function () { mostrarPausa(tarjetas[indiceActivo]); }).catch(function () {});
          } else {
            mostrarPausa(tarjetas[indiceActivo]);
          }
        }
      }

      requestAnimationFrame(function () {
        pista.style.transition = '';
        tarjetas.forEach(function (t) { t.style.transition = ''; });
      });
    }

    pista.addEventListener('transitionend', function (e) {
      if (e.target !== pista || e.propertyName !== 'transform') return;
      quizasResetearPosicion();
    });

    tarjetas.forEach(function (tarjeta, i) {
      var video = tarjeta.querySelector('.tv-video');
      var btnSonido = tarjeta.querySelector('.tv-boton-sonido');
      if (!video) return;

      video.muted = true;
      aplicarIconoSonido(tarjeta);
      cargarPrimerFrame(video);

      tarjeta.querySelector('.tv-video-envoltorio').addEventListener('click', function (e) {
        if (e.target.closest('.tv-boton-sonido')) return;
        if (i === indiceActivo) {
          if (video.paused) {
            var p = video.play();
            if (p && typeof p.then === 'function') {
              p.then(function () { mostrarPausa(tarjeta); }).catch(function () {});
            }
          } else {
            video.pause();
            mostrarPlay(tarjeta);
          }
        } else {
          moverA(i);
        }
      });

      if (btnSonido) {
        btnSonido.addEventListener('click', function (e) {
          e.stopPropagation();
          muteado = !muteado;
          aplicarMuteGlobal();
        });
      }
    });

    btnAnterior.addEventListener('click', function () { moverA(indiceActivo - 1); });
    btnSiguiente.addEventListener('click', function () { moverA(indiceActivo + 1); });

    var inicioTactil = null;
    pista.addEventListener('touchstart', function (e) { inicioTactil = e.touches[0].clientX; }, { passive: true });
    pista.addEventListener('touchend', function (e) {
      if (inicioTactil === null) return;
      var diff = inicioTactil - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) moverA(diff > 0 ? indiceActivo + 1 : indiceActivo - 1);
      inicioTactil = null;
    });

    var timerResize = null;
    window.addEventListener('resize', function () {
      clearTimeout(timerResize);
      timerResize = setTimeout(function () {
        pista.style.transition = 'none';
        pista.style.transform = 'translateX(' + (-calcularOffset(indiceActivo)) + 'px)';
        pista.offsetHeight;
        pista.style.transition = '';
      }, 100);
    });

    tarjetas[indiceActivo].classList.add('tv-tarjeta--reproduciendo');
    requestAnimationFrame(function () {
      pista.style.transition = 'none';
      pista.style.transform = 'translateX(' + (-calcularOffset(indiceActivo)) + 'px)';
      pista.offsetHeight;
      pista.style.transition = '';
    });

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && !yaIniciado) {
            yaIniciado = true;
            reproducirEnIndice(indiceActivo);
          }
        });
      }, { threshold: 0.25 });
      observer.observe(seccion);
    } else {
      reproducirEnIndice(indiceActivo);
    }
  }

  function iniciarTodos() {
    document.querySelectorAll('[id^="tv-seccion-"]').forEach(function (sec) {
      var id = sec.id.replace('tv-seccion-', '');
      iniciarCarrusel(id);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciarTodos);
  } else {
    iniciarTodos();
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      var id = e.detail.sectionId;
      if (document.getElementById('tv-seccion-' + id)) iniciarCarrusel(id);
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["videos-clientes"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciarCarrusel(idSeccion, indiceDestacado) {
    var pista = document.getElementById('tv-pista-' + idSeccion);
    var btnAnterior = document.getElementById('tv-anterior-' + idSeccion);
    var btnSiguiente = document.getElementById('tv-siguiente-' + idSeccion);

    if (!pista) return;

    var tarjetas = pista.querySelectorAll('.tv-tarjeta');
    var totalTarjetas = tarjetas.length;
    var indiceActual = 0;
    var videoActivo = null;

    function anchoTarjeta(i) {
      return tarjetas[i].getBoundingClientRect().width + parseFloat(getComputedStyle(pista).gap);
    }

    function calcularOffset(indice) {
      var offset = 0;
      for (var i = 0; i < indice; i++) {
        offset += anchoTarjeta(i);
      }
      var contenedor = pista.parentElement;
      var anchoContenedor = contenedor.getBoundingClientRect().width;
      var anchoTarjetaActual = tarjetas[indice].getBoundingClientRect().width;
      var paddingIzq = parseFloat(getComputedStyle(pista).paddingLeft);
      offset -= (anchoContenedor - anchoTarjetaActual) / 2 - paddingIzq;
      return offset;
    }

    function moverA(indice) {
      if (indice < 0) indice = 0;
      if (indice >= totalTarjetas) indice = totalTarjetas - 1;
      indiceActual = indice;
      var offset = calcularOffset(indiceActual);
      pista.style.transform = 'translateX(-' + Math.max(0, offset) + 'px)';
      actualizarBotones();
    }

    function actualizarBotones() {
      btnAnterior.disabled = indiceActual === 0;
      btnSiguiente.disabled = indiceActual >= totalTarjetas - 1;
    }

    function detenerVideo(video) {
      if (!video) return;
      video.pause();
      video.currentTime = 0;
      var envoltorio = video.closest('.tv-video-envoltorio');
      if (!envoltorio) return;
      var btnPlay = envoltorio.querySelector('.tv-boton-play');
      var btnPausa = envoltorio.querySelector('.tv-boton-pausa');
      if (btnPlay) { btnPlay.style.display = ''; btnPlay.classList.add('tv-boton-play--visible'); }
      if (btnPausa) btnPausa.style.display = 'none';
    }

    tarjetas.forEach(function (tarjeta) {
      var envoltorio = tarjeta.querySelector('.tv-video-envoltorio');
      var video = tarjeta.querySelector('.tv-video');
      var btnPlay = tarjeta.querySelector('.tv-boton-play');
      var btnPausa = tarjeta.querySelector('.tv-boton-pausa');
      var btnSonido = tarjeta.querySelector('.tv-boton-sonido');
      var iconoMute = tarjeta.querySelector('.tv-icono-mute');
      var iconoSonido = tarjeta.querySelector('.tv-icono-sonido');

      if (!video) return;

      function reproducir() {
        if (videoActivo && videoActivo !== video) detenerVideo(videoActivo);
        videoActivo = video;
        video.play();
        btnPlay.classList.remove('tv-boton-play--visible');
        btnPlay.style.display = '';
        btnPausa.style.display = '';
        btnPausa.style.opacity = '0';
      }

      function pausar() {
        video.pause();
        btnPausa.style.display = 'none';
        btnPlay.style.display = '';
        btnPlay.classList.add('tv-boton-play--visible');
      }

      envoltorio.addEventListener('click', function (e) {
        if (e.target.closest('.tv-boton-sonido')) return;
        if (video.paused) {
          reproducir();
        } else {
          pausar();
        }
      });

      envoltorio.addEventListener('mouseenter', function () {
        if (!video.paused) {
          btnPausa.style.opacity = '1';
        }
      });

      envoltorio.addEventListener('mouseleave', function () {
        btnPausa.style.opacity = '0';
      });

      if (btnSonido) {
        btnSonido.addEventListener('click', function (e) {
          e.stopPropagation();
          video.muted = !video.muted;
          if (video.muted) {
            iconoMute.style.display = '';
            iconoSonido.style.display = 'none';
          } else {
            iconoMute.style.display = 'none';
            iconoSonido.style.display = '';
          }
        });
      }
    });

    btnAnterior.addEventListener('click', function () {
      moverA(indiceActual - 1);
    });

    btnSiguiente.addEventListener('click', function () {
      moverA(indiceActual + 1);
    });

    var inicioTactil = null;
    pista.addEventListener('touchstart', function (e) {
      inicioTactil = e.touches[0].clientX;
    }, { passive: true });

    pista.addEventListener('touchend', function (e) {
      if (inicioTactil === null) return;
      var diff = inicioTactil - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) {
        moverA(diff > 0 ? indiceActual + 1 : indiceActual - 1);
      }
      inicioTactil = null;
    });

    moverA(Math.max(0, indiceDestacado - 1));
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[id^="tv-seccion-"]').forEach(function (sec) {
      var id = sec.id.replace('tv-seccion-', '');
      var destacado = parseInt(sec.dataset.indiceDestacado || '3', 10) - 1;
      iniciarCarrusel(id, destacado);
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
